import { get } from "services/api";
import { RAISE_QUERY_URL } from "constants/endpoints";
import { BRANDS_TO_FETCH } from "./constants";

export const fetchBrands = async () => {
  const QUERY = BRANDS_TO_FETCH.map(({ query }) => query).join("&brandIds[]=");
  const URL = `${RAISE_QUERY_URL}?type=multipleBrands&searchType=1&brandIds=${QUERY}`;
  const brandsResponse = await get(URL, {
    credentials: "same-origin"
  });
  return brandsResponse.data;
};
